import { TrackFocusDirective } from './track-focus.directive';
import { NgModule } from '@angular/core';


@NgModule({
  declarations: [TrackFocusDirective],
  exports: [TrackFocusDirective],
})
export class TrackFocusModule { }
